import {
    EP_AUTH_CHANGE_PASSWORD,
    EP_AUTH_CHANGE_USERNAME,
    EP_AUTH_PASSWORD_SETUP_REQUEST,
    EP_AUTH_DELETE_CONFIRM,
    EP_AUTH_DELETE_REQUEST,
    EP_AUTH_FORGOT_PASSWORD,
    EP_AUTH_GOOGLE,
    EP_AUTH_GOOGLE_COMPLETE,
    EP_AUTH_LOGIN,
    EP_AUTH_LOGOUT,
    EP_AUTH_ME,
    EP_AUTH_PUBLIC_CONFIG,
    EP_AUTH_REGISTER_COMPLETE,
    EP_AUTH_REGISTER_START,
    EP_AUTH_REGISTER_VERIFY,
    EP_AUTH_RESEND_VERIFICATION,
    EP_AUTH_RESET_PASSWORD,
    EP_MY_ROOM,
    EP_GUEST_SESSION,
    EP_GUEST_LOGOUT,
} from '../constants/endPointConstants';
import api from './Api';
import { refreshSession } from './SessionRefresh';

const registerStart = async (email, is18Confirmed) => {
    const response = await api.post(EP_AUTH_REGISTER_START, { email, is18Confirmed });
    return response?.data;
};

const registerVerify = async (email, code) => {
    const response = await api.post(EP_AUTH_REGISTER_VERIFY, { email, code });
    return response?.data;
};

const registerComplete = async (registrationTicket, username, password, confirmPassword) => {
    const response = await api.post(EP_AUTH_REGISTER_COMPLETE, {
        registrationTicket,
        username,
        password,
        confirmPassword,
    });
    return response?.data;
};

const resendVerification = async (email) => {
    const response = await api.post(EP_AUTH_RESEND_VERIFICATION, { email });
    return response?.data;
};

const login = async (identifier, password) => {
    const response = await api.post(EP_AUTH_LOGIN, { identifier, password });
    return response?.data;
};

const googleLogin = async (idToken) => {
    const response = await api.post(EP_AUTH_GOOGLE, { idToken });
    return response?.data;
};

const googleComplete = async (googleTicket, is18Confirmed, username) => {
    const response = await api.post(EP_AUTH_GOOGLE_COMPLETE, {
        googleTicket,
        is18Confirmed,
        username,
    });
    return response?.data;
};

const logout = async (refreshToken) => {
    const response = await api.post(EP_AUTH_LOGOUT, { refreshToken });
    return response?.data;
};

const forgotPassword = async (email) => {
    const response = await api.post(EP_AUTH_FORGOT_PASSWORD, { email });
    return response?.data;
};

const resetPassword = async (email, code, newPassword, confirmPassword) => {
    const response = await api.post(EP_AUTH_RESET_PASSWORD, { email, code, newPassword, confirmPassword });
    return response?.data;
};

const changePassword = async (currentPassword, newPassword, confirmPassword, verificationCode = '') => {
    const response = await api.post(EP_AUTH_CHANGE_PASSWORD, { currentPassword, newPassword, confirmPassword, verificationCode });
    return response?.data;
};

const changeUsername = async (username) =>
    (await api.post(EP_AUTH_CHANGE_USERNAME, { username }))?.data;

const requestPasswordSetup = async () => (await api.post(EP_AUTH_PASSWORD_SETUP_REQUEST))?.data;

const me = async () => {
    const response = await api.get(EP_AUTH_ME, { timeout: 10000 });
    return response?.data;
};

const requestAccountDeletion = async () => {
    const response = await api.post(EP_AUTH_DELETE_REQUEST);
    return response?.data;
};

const confirmAccountDeletion = async (code = '', googleIdToken = '') => {
    const response = await api.post(EP_AUTH_DELETE_CONFIRM, { code, googleIdToken });
    return response?.data;
};

const getPublicConfig = async () => {
    const response = await api.get(EP_AUTH_PUBLIC_CONFIG, { _anonymous: true });
    return response?.data;
};

const getMyRoom = async (options = {}) => {
    const response = await api.get(EP_MY_ROOM, options);
    return response?.data;
};

const createGuestSession = async () => (await api.post(EP_GUEST_SESSION, {}, { _anonymous: true }))?.data;
const logoutGuestSession = async () => api.post(EP_GUEST_LOGOUT);

export {
    registerStart,
    registerVerify,
    registerComplete,
    resendVerification,
    login,
    googleLogin,
    googleComplete,
    refreshSession,
    logout,
    forgotPassword,
    resetPassword,
    changePassword,
    changeUsername,
    requestPasswordSetup,
    me,
    requestAccountDeletion,
    confirmAccountDeletion,
    getPublicConfig,
    getMyRoom,
    createGuestSession,
    logoutGuestSession,
};
